export default __webpack_public_path__ + "Cassette_3_FW_Single.png";